import { render, staticRenderFns } from "./GuichetsNews.vue?vue&type=template&id=5a370d83&"
import script from "./GuichetsNews.vue?vue&type=script&lang=js&"
export * from "./GuichetsNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports